import { useDispatch, useSelector } from 'react-redux';

import { openDrawer } from 'store/reducers/ui';

export default function ({ item, isLoading }) {
  const dispatch = useDispatch();
  const { isOwner, uuid: userUuid } = useSelector((state) => state.user);
  if (isLoading) return 'loading';

  const onClick = (e) => {
    e.preventDefault();
    dispatch(openDrawer({ type: 'groomer-edit', uuid: item.user.uuid }));
  };

  // If groomer isn't the business owner, only allow them to edit their information
  if (!isOwner && userUuid !== item.user.uuid) return;

  return (
    <button
      onClick={onClick}
      className="no-style-btn w-fit fw-400 c-primary-orange pointer"
    >
      Edit
    </button>
  );
}
